<template>
    <div class="modal fade" id="arquivo_digital_update_modal" data-backdrop="static">
        <div class="modal demo-modal">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            <b>Atualizar</b>
                        </h5>
                    </div>
                    <div class="modal-body"> 

                        <dot :isVisible="isLoading"></dot>

                        <div v-if="!isLoading">
                            <div class="alert alert-danger" v-if="errors.length > 0">
                                <ul>
                                    <li v-for="error in errors">{{ error }}</li>
                                </ul>
                            </div>

                            <!-- <div class="row form-group">
                                <div class="col-lg-12">
                                    <label class="col-form-label" for="title">Competência:</label>
                                    <input style="height: 44px;" type="number" placeholder="Ex: 2022" v-model="update_arquivo_digital.competencia" class="form-control">
                                </div>
                            </div> -->

                            <div class="form-group">
                                <label class="col-form-label" for="title">Descrição Resumida:</label>
                                <textarea
                                    id="descricaoResumida"
                                    class="form-control" 
                                    rows="4"
                                    v-model="update_arquivo_digital.descricao_resumida"
                                    placeholder="Descrição..."></textarea>
                            </div>

                            <div v-if="update_arquivo_digital.tipo == 'empenho'">
                                <div class="row form-group">
                                    <div class="col-lg-4">
                                        <label class="col-form-label">Número do Empenho:</label>
                                        <the-mask 
                                        class="form-control"
                                        placeholder="12345678/2022"
                                        :mask="['########/####']"
                                        :masked="configDateMask.maskedValue"
                                        v-model="update_arquivo_digital.empenho_numero"/>
                                    </div>
                                    <div class="col-lg-4">
                                        <label class="col-form-label" for="title">Espécie:</label>
                                        <input type="text" placeholder="Ex: Ordinário" 
                                        v-model="update_arquivo_digital.empenho_especie" class="form-control">
                                    </div>
                                    <div class="col-lg-4">
                                        <label class="col-form-label" for="title">Data Emissão:</label>
                                        <the-mask 
                                        class="form-control"
                                        placeholder="01/01/2021"
                                        :mask="['##/##/####']"
                                        :masked="configDateMask.maskedValue"
                                        v-model="update_arquivo_digital.empenho_data_emissao"/>
                                    </div>
                                </div>
                                <div class="row form-group">
                                    <div class="col-lg-6">
                                        <label class="col-form-label">Credor:</label>
                                        <input type="text" placeholder="1 - Joao da Silva" v-model="update_arquivo_digital.empenho_credor" class="form-control">
                                    </div>
                                    <div class="col-lg-6">
                                        <label class="col-form-label" for="title">CPF/CNPJ do Credor:</label>
                                        <the-mask 
                                        class="form-control"
                                        placeholder="123.456.789-09/12.345.678/0001-00"
                                        :mask="['###.###.###-##', '##.###.###/####-##']"
                                        :masked="configDateMask.maskedValue"
                                        v-model="update_arquivo_digital.empenho_documento_credor"/>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label class="col-form-label" for="title">Objeto do Empenho:</label>
                                    <textarea 
                                        class="form-control" 
                                        rows="4"
                                        v-model="update_arquivo_digital.empenho_objeto"
                                        placeholder="Objeto do Empenho..."></textarea>
                                </div>
                                <div class="row form-group">
                                    <div class="col-lg-6">
                                        <label class="col-form-label" for="title">Unidade Orçamentária do Empenho:</label>
                                        <basic-select :options="unidades_orcamentarias"
                                                :selected-option="unidade_orcamentaria"
                                                placeholder="Selecione a unidade orçamentária"
                                                @select="onSelectUnidadeOrcamentaria">
                                        </basic-select>
                                    </div>

                                    <div class="col-lg-6">
                                        <label class="col-form-label">Fornecedor:</label>
                                        <input type="text" placeholder="Fornecedor" v-model="update_arquivo_digital.empenho_fornecedor" class="form-control">
                                    </div>
                                </div>
                                <div class="row form-group">
                                    <div class="col-lg-6">
                                        <label class="col-form-label">Classificação da Despesa do Empenho:</label>
                                        <input type="text" placeholder="1.23.45.67 - Classificação" v-model="update_arquivo_digital.empenho_classificacao_despesa" class="form-control">
                                    </div>
                                    <div class="col-lg-6">
                                        <label class="col-form-label">Ação do Empenho:</label>
                                        <input type="text" placeholder="1.23 - Ação" v-model="update_arquivo_digital.empenho_acao" class="form-control">
                                    </div>
                                </div>
                                <div class="row form-group">
                                    <div class="col-lg-6">
                                        <label class="col-form-label" for="title">Fonte de Recursos Empenho:</label>
                                        <input type="text" placeholder="1.23.45.67 - Classificação" v-model="update_arquivo_digital.empenho_fonte_recursos" class="form-control">
                                    </div>
                                    <div class="col-lg-6">
                                        <label class="col-form-label" for="title">Unidade Gestora:</label>
                                        <basic-select :options="unidades_gestoras"
                                                :selected-option="unidade_gestora"
                                                placeholder="Selecione a Unidade Gestora"
                                                @select="onSelectUnidadeGestora">
                                        </basic-select>
                                    </div>
                                </div>
                                <div class="row form-group">
                                    <div class="col-lg-6">
                                        <label class="col-form-label" for="title">Data de Liquidação:</label>
                                        <the-mask 
                                        class="form-control"
                                        placeholder="01/01/2021"
                                        :mask="['##/##/####']"
                                        :masked="configDateMask.maskedValue"
                                        v-model="update_arquivo_digital.empenho_data_liquidacao"/>
                                    </div>
                                    <div class="col-lg-6">
                                        <label class="col-form-label" for="title">Data de Pagamento:</label>
                                        <the-mask 
                                        class="form-control"
                                        placeholder="01/01/2021"
                                        :mask="['##/##/####']"
                                        :masked="configDateMask.maskedValue"
                                        v-model="update_arquivo_digital.empenho_data_pagamento"/>
                                    </div>
                                </div>
                                <div class="form-group ">
                                    <label class="col-form-label" for="title">Valor do Empenho:</label>
                                    <money 
                                    class="form-control"
                                    v-model="update_arquivo_digital.empenho_valor" 
                                    v-bind="money"></money>
                                </div>
                            </div>
                            <div v-if="update_arquivo_digital.tipo == 'liquidacao'">
                                <div class="form-group">
                                    <label class="col-form-label" for="title">Empenho:</label>
                                    <basic-select :options="empenhos"
                                            :selected-option="empenho"
                                            placeholder="Selecione o empenho"
                                            @select="onSelectEmpenho">
                                    </basic-select>
                                </div>
                                <div class="row form-group">
                                    <div class="col-lg-4">
                                        <label class="col-form-label" for="title">Data Vencimento:</label>
                                        <the-mask 
                                        class="form-control"
                                        placeholder="01/01/2021"
                                        :mask="['##/##/####']"
                                        :masked="configDateMask.maskedValue"
                                        v-model="update_arquivo_digital.liquidacao_data_vencimento"/>
                                    </div>
                                    <div class="col-lg-4">
                                        <label class="col-form-label">Número Aviso de Liquidação:</label>
                                        <input type="number" placeholder="Nome do Órgão" v-model="update_arquivo_digital.liquidacao_numero_aviso" class="form-control">
                                    </div>
                                    <div class="col-lg-4">
                                        <label class="col-form-label" for="title">Data de Emissão:</label>
                                        <the-mask 
                                        class="form-control"
                                        placeholder="01/01/2021"
                                        :mask="['##/##/####']"
                                        :masked="configDateMask.maskedValue"
                                        v-model="update_arquivo_digital.liquidacao_data_emissao"/>
                                    </div>
                                </div>
                                <div class="row form-group">
                                    <div class="col-lg-6">
                                        <label class="col-form-label">Documento Fiscal:</label>
                                        <input type="text" placeholder="Documento Fiscal" v-model="update_arquivo_digital.liquidacao_documento_fiscal" class="form-control">
                                    </div>
                                    <div class="col-lg-6">
                                        <label class="col-form-label" for="title">Valor da Liquidação:</label>
                                        <money 
                                        class="form-control"
                                        v-model="update_arquivo_digital.liquidacao_valor"
                                        v-bind="money"></money>
                                    </div>
                                </div>
                            </div>
                            <div v-if="update_arquivo_digital.tipo == 'pagamento'">
                                <div class="form-group">
                                    <label class="col-form-label" for="title">Liquidação:</label>
                                    <basic-select :options="liquidacoes"
                                            :selected-option="liquidacao"
                                            placeholder="Selecione a liquidação"
                                            @select="onSelectLiquidacao">
                                    </basic-select>
                                </div>
                                <div class="row form-group">
                                    <div class="col-lg-6">
                                        <label class="col-form-label" for="title">Data de Movimentação:</label>
                                        <the-mask 
                                        class="form-control"
                                        placeholder="01/01/2021"
                                        :mask="['##/##/####']"
                                        :masked="configDateMask.maskedValue"
                                        v-model="update_arquivo_digital.pagamento_data_movimentacao"/>
                                    </div>
                                    <div class="col-lg-6">
                                        <label class="col-form-label">Número de Sequência:</label>
                                        <input type="number" placeholder="Número de Sequência" v-model="update_arquivo_digital.pagamento_numero_sequencia" class="form-control">
                                    </div>
                                </div>
                                <div class="row form-group">
                                    <div class="col-lg-6">
                                        <label class="col-form-label" for="title">Valor do Pagamento:</label>
                                        <money 
                                        class="form-control"
                                        v-model="update_arquivo_digital.pagamento_valor_pago"
                                        v-bind="money"></money>
                                    </div>
                                    <div class="col-lg-6">
                                        <label class="col-form-label">Conta Contábil:</label>
                                        <input type="text" placeholder="Conta Contábil" v-model="update_arquivo_digital.pagamento_conta_contabil" class="form-control">
                                    </div>
                                </div>
                            </div>
                            <div v-if="update_arquivo_digital.tipo == 'prestacao_contas'">
                                <div class="row form-group">
                                    <div class="col-lg-6">
                                        <label class="col-form-label">Nome:</label>
                                        <input type="text" placeholder="Nome" v-model="update_arquivo_digital.prestacao_contas_nome" class="form-control">
                                    </div>
                                    <div class="col-lg-6">
                                        <label class="col-form-label">Ano:</label>
                                        <input type="number" placeholder="Número Aviso de Liquidação" v-model="update_arquivo_digital.prestacao_contas_ano" class="form-control">
                                    </div>
                                </div>
                            </div>
                            <div v-if="update_arquivo_digital.tipo == 'licitacao'">
                                <div class="row form-group">
                                    <div class="col-lg-1" style="display: flex;align-items: center;">
                                        <label class="col-form-label" for="title">Órgão(s):</label>
                                    </div>
                                    <div :class="(itemsOrgaosLicitacao.length == 0) ? 'col-lg-11' : 'col-lg-10'">
                                        <multi-select 
                                            :options="orgaos"
                                            :selected-options="itemsOrgaosLicitacao"
                                            placeholder="Selecione o órgão"
                                            @select="onSelectOrgaoLicitacao">
                                        </multi-select>
                                    </div>
                                    <div class="col-lg-1" style="padding-left: 0px;" v-if="itemsOrgaosLicitacao.length > 0">
                                        <button type="button" class="btn btn-outline-danger btn-clear-orgaos-selected-licitacao" @click="resetOrgaosLicitacao()">
                                             <i class="mdi mdi-backspace"></i>
                                        </button>
                                    </div>
                                </div>
                                <div class="row form-group">
                                    <div class="col-lg-6">
                                        <label class="col-form-label">Número da Licitação:</label>
                                        <input type="number" placeholder="Número da Licitação" v-model="update_arquivo_digital.licitacao_numero" class="form-control">
                                    </div>
                                    <div class="col-lg-6">
                                        <label class="col-form-label" for="title">Modalidade:</label>
                                        <basic-select :options="modalidades_licitacao"
                                                :selected-option="modalidade_licitacao"
                                                placeholder="Selecione a modalidade"
                                                @select="onSelectModalidade">
                                        </basic-select>
                                    </div>
                                </div>
                                <div class="row form-group">
                                    <div class="col-lg-6">
                                        <label class="col-form-label" for="title">Data da Licitação:</label>
                                        <the-mask 
                                        class="form-control"
                                        placeholder="01/01/2021"
                                        :mask="['##/##/####']"
                                        :masked="configDateMask.maskedValue"
                                        v-model="update_arquivo_digital.licitacao_data"/>
                                    </div>
                                    <div class="col-lg-6">
                                        <label class="col-form-label" for="title">Valor da Licitação:</label>
                                        <money 
                                        class="form-control"
                                        v-model="update_arquivo_digital.licitacao_valor"
                                        v-bind="money"></money>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label class="col-form-label" for="title">Objeto da Licitação:</label>
                                    <textarea
                                        class="form-control" 
                                        rows="4"
                                        v-model="update_arquivo_digital.licitacao_objeto"
                                        placeholder="Objeto da Licitação..."></textarea>
                                </div>
                                <div class="row form-group" v-for="(find, index) in update_arquivo_digital.licitacao_vencedor">
                                    <div class="col-lg-3" style="display: flex;align-items: center;">
                                        <label class="col-form-label" for="title">Vencedor da Licitação:</label>
                                    </div>
                                    <div class="col-lg-8" style="padding-left: 0px;">
                                        <input type="text" placeholder="Vencedor da Licitação"  v-model="update_arquivo_digital.licitacao_vencedor[index]" class="form-control">
                                    </div>
                                    <div class="col-lg-1" style="padding-left: 0px;">
                                        <span v-if="index == 0">
                                            <button type="button" class="btn btn-outline-primary button-add-remove-input" @click="addInputVencedorLicitacao()">
                                                 <i class="mdi mdi-plus-circle"></i>
                                            </button>
                                        </span>
                                        <span v-if="index > 0">
                                            <button type="button" class="btn btn-outline-danger button-add-remove-input" @click="removeInputVencedorLicitacao(index)">
                                                 <i class="mdi mdi-trash-can"></i>
                                            </button>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="update_arquivo_digital.tipo == 'setor_pessoal'">
                            <div class="row form-group">
                                <div class="col-lg-6">
                                    <label class="col-form-label" for="title">Nome:</label>
                                    <input type="text" placeholder="Nome" v-model="update_arquivo_digital.setor_pessoal_nome" class="form-control">
                                </div>
                                <div class="col-lg-6">
                                    <label class="col-form-label" for="title">CPF:</label>
                                    <the-mask
                                        class="form-control" 
                                        placeholder="012.456.789-00" 
                                        v-model="update_arquivo_digital.setor_pessoal_cpf"
                                        :mask="['###.###.###-##']"/> 
                                </div>
                            </div>
                            <div class="form-group">
                                <label class="col-form-label" for="title">Cargo:</label>
                                <input type="text" placeholder="Cargo" v-model="update_arquivo_digital.setor_pessoal_cargo" class="form-control">
                            </div>
                            <div class="form-group">
                                <label class="col-form-label" for="title">Secretaria:</label>
                                <input type="text" placeholder="Cargo" v-model="update_arquivo_digital.setor_pessoal_secretaria" class="form-control">
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-light" data-dismiss="modal">Cancelar</button>
                        <button type="button" class="btn btn-success"
                            @click.prevent.stop="updateArquivoDigital">
                            Salvar
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
    .modal-dialog {
        min-width: 700px;
    }
    .button-add-remove-input {
        width: 45px; 
        font-size: 18px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .btn-clear-orgaos-selected-licitacao {
        width: 45px; 
        font-size: 18px;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 32px;
    }
</style>

<script>
    import moment from 'moment';
    import { Money } from 'v-money';
	import { eventBus } from '../../app';
    import Dot from '../loadder/Dot.vue';
    import { TheMask } from 'vue-the-mask';
    import { BasicSelect, MultiSelect } from 'vue-search-select';

    export default {

    	components: {
            Dot,
            Money,
            TheMask,
            BasicSelect,
            MultiSelect
        },


    	data(){
            return {
                configDateMask: {
                    maskedValue: true
                },
                //MASK-MONEY
                money: {
                    decimal: ',',
                    thousands: '.',
                    prefix: 'R$ ',
                    //suffix: ' #',
                    precision: 2,
                    masked: false
                },
                currentPagePagination: null,

            	isLoading: false,

                //ARRAYS
            	errors: [],
                empenhos: [],
                liquidacoes: [],
                modalidades_licitacao: [
                    {
                        'text': 'Concorrência', 
                        'value': 'concorrencia'
                    },
                    {
                        'text': 'Pregão Presencial', 
                        'value': 'pregao_presencial'
                    },
                    {
                        'text': 'Pregão Eletrônico', 
                        'value': 'pregao_eletronico'
                    },
                    {
                        'text': 'Tomada de Preços', 
                        'value': 'tomada_precos'
                    },
                    {
                        'text': 'Dispensa Presencial', 
                        'value': 'dispensa_presencial'
                    },
                    {
                        'text': 'Dispensa Eletrônica', 
                        'value': 'dispensa_eletronica'
                    }
                ],
                orgaos: [],
                unidades_orcamentarias: [],
                unidades_gestoras: [],

                //OBJECTS
                empenho: {},
                liquidacao: {},
                modalidade_licitacao: {},
                orgao: {},
                unidade_orcamentaria: {},
                unidade_gestora: {},
                update_arquivo_digital: {},
                itemsOrgaosLicitacao: [],
                lastSelectItemOrgaoLicitacao: {},
            }
        },

        mounted(){
        	this.registryEventOpenModalUpdateArquivoDigital();
        },

        methods: {
            addInputVencedorLicitacao(){
                this.update_arquivo_digital.licitacao_vencedor.push('');
            },
            removeInputVencedorLicitacao(indexFind){
                if(indexFind > 0){
                    this.update_arquivo_digital.licitacao_vencedor.splice(indexFind, 1);
                }
            },
            registryEventOpenModalUpdateArquivoDigital(){
                eventBus.$on('eventOpenModalUpdateArquivoDigital', (updateArquivoDigital, currentPage) => {
                	this.errors = [];
                    this.currentPagePagination = currentPage;
                    this.setDataArquivoDigital(updateArquivoDigital);
                    this.getUnidadesGestoras();
                    $("#arquivo_digital_update_modal").modal("show");
                });
            },
            onSelectUnidadeOrcamentaria(item) {
                this.unidade_orcamentaria = item;
                this.update_arquivo_digital.empenho_unidade_orcamentaria_id = this.unidade_orcamentaria.value;
            },
            onSelectOrgaoLicitacao(itemsParam, lastSelectItemParam) {
                let me = this;
                me.itemsOrgaosLicitacao = itemsParam;
                me.lastSelectItemOrgaoLicitacao = lastSelectItemParam;
                me.update_arquivo_digital.licitacao_orgaos = [];
                $.each(me.itemsOrgaosLicitacao, function (key, itemOrgao) {
                    me.update_arquivo_digital.licitacao_orgaos.push(itemOrgao.value);
                });
            },
            resetOrgaosLicitacao() {
                this.itemsOrgaosLicitacao = [];
                this.update_arquivo_digital.licitacao_orgaos = [];
            },
            onSelectEmpenho(item) {
                this.empenho = item;
                this.update_arquivo_digital.liquidacao_empenho_numero = this.empenho.value;
            },
            onSelectLiquidacao(item){
                this.liquidacao = item;
                this.update_arquivo_digital.pagamento_liquidacao_numero_aviso = this.liquidacao.value;
            },
            onSelectModalidade(item){
                this.modalidade_licitacao = item;
                this.update_arquivo_digital.licitacao_modalidade = this.modalidade_licitacao.value;
            },
            onSelectUnidadeGestora(item) {
                this.unidade_gestora = item;
                this.update_arquivo_digital.empenho_unidade_gestora_id = this.unidade_gestora.value;
            },

            async setDataArquivoDigital(arquivoDigitalParam){
                let me = this;
                this.errors = [];
                if(arquivoDigitalParam.tipo == 'empenho'){
                    var dataEmissaoEmpenhoLocal = moment(arquivoDigitalParam.empenho_data_emissao).format('DD/MM/YYYY');
                    var dataLiquidacaoEmpenhoLocal = (arquivoDigitalParam.empenho_data_liquidacao) ? moment(arquivoDigitalParam.empenho_data_liquidacao).format('DD/MM/YYYY') : null;
                    var dataPagamentoEmpenhoLocal = (arquivoDigitalParam.empenho_data_pagamento) ? moment(arquivoDigitalParam.empenho_data_pagamento).format('DD/MM/YYYY') : null;
                    this.update_arquivo_digital = Object.assign({}, {
                        id: arquivoDigitalParam.id,
                        tipo: arquivoDigitalParam.tipo,
                        competencia: arquivoDigitalParam.competencia,
                        descricao_resumida: arquivoDigitalParam.descricao_resumida,
                        empenho_numero: arquivoDigitalParam.empenho_numero,
                        empenho_especie: arquivoDigitalParam.empenho_especie,
                        empenho_data_emissao: dataEmissaoEmpenhoLocal,
                        empenho_credor: arquivoDigitalParam.empenho_credor,
                        empenho_documento_credor: arquivoDigitalParam.empenho_documento_credor,
                        empenho_objeto: arquivoDigitalParam.empenho_objeto,
                        empenho_unidade_orcamentaria_id: arquivoDigitalParam.empenho_unidade_orcamentaria_id,
                        empenho_fornecedor: arquivoDigitalParam.empenho_fornecedor,
                        empenho_classificacao_despesa: arquivoDigitalParam.empenho_classificacao_despesa,
                        empenho_acao: arquivoDigitalParam.empenho_acao,
                        empenho_fonte_recursos: arquivoDigitalParam.empenho_fonte_recursos,
                        empenho_unidade_gestora_id: arquivoDigitalParam.empenho_unidade_gestora_id,
                        empenho_data_liquidacao: dataLiquidacaoEmpenhoLocal,
                        empenho_data_pagamento: dataPagamentoEmpenhoLocal,
                        empenho_valor: arquivoDigitalParam.empenho_valor,
                    });
                    this.orgao = {
                        value: arquivoDigitalParam.empenho_orgao_orcamentario_id,
                        text: arquivoDigitalParam.empenho_orgao_orcamentario_nome
                    };
                    this.unidade_orcamentaria = {
                        value: arquivoDigitalParam.empenho_unidade_orcamentaria_id,
                        text: arquivoDigitalParam.empenho_unidade_orcamentaria_nome
                    };
                    this.unidade_gestora = {
                        value: arquivoDigitalParam.empenho_unidade_gestora_id,
                        text: arquivoDigitalParam.empenho_unidade_gestora_nome
                    };
                    this.getOrgaos();
                    this.getUnidadesOrcamentarias();
                }
                else if(arquivoDigitalParam.tipo == 'liquidacao'){
                    var dataVencimentoLiquidacaoLocal = moment(arquivoDigitalParam.liquidacao_data_vencimento).format('DD/MM/YYYY');
                    var dataEmissaoLiquidacaoLocal = moment(arquivoDigitalParam.liquidacao_data_emissao).format('DD/MM/YYYY');
                    this.update_arquivo_digital = Object.assign({}, {
                        id: arquivoDigitalParam.id,
                        tipo: arquivoDigitalParam.tipo,
                        competencia: arquivoDigitalParam.competencia,
                        descricao_resumida: arquivoDigitalParam.descricao_resumida,
                        liquidacao_empenho_numero: arquivoDigitalParam.liquidacao_empenho_numero,
                        liquidacao_data_vencimento: dataVencimentoLiquidacaoLocal,
                        liquidacao_numero_aviso: arquivoDigitalParam.liquidacao_numero_aviso,
                        liquidacao_data_emissao: dataEmissaoLiquidacaoLocal,
                        liquidacao_documento_fiscal: arquivoDigitalParam.liquidacao_documento_fiscal,
                        liquidacao_valor: arquivoDigitalParam.liquidacao_valor
                    });
                    this.getEmpenhos();
                }
                else if(arquivoDigitalParam.tipo == 'pagamento'){
                    var dataMovimentacaoLocal = moment(arquivoDigitalParam.pagamento_data_movimentacao).format('DD/MM/YYYY');
                    this.update_arquivo_digital = Object.assign({}, {
                        id: arquivoDigitalParam.id,
                        tipo: arquivoDigitalParam.tipo,
                        competencia: arquivoDigitalParam.competencia,
                        descricao_resumida: arquivoDigitalParam.descricao_resumida,
                        pagamento_liquidacao_numero_aviso: arquivoDigitalParam.pagamento_liquidacao_numero_aviso,
                        pagamento_data_movimentacao: dataMovimentacaoLocal,
                        pagamento_numero_sequencia: arquivoDigitalParam.pagamento_numero_sequencia,
                        pagamento_valor_pago: arquivoDigitalParam.pagamento_valor_pago,
                        pagamento_conta_contabil: arquivoDigitalParam.pagamento_conta_contabil
                    });
                    this.getLiquidacoes();
                }
                else if(arquivoDigitalParam.tipo == 'prestacao_contas'){
                    this.update_arquivo_digital = Object.assign({}, {
                        id: arquivoDigitalParam.id,
                        tipo: arquivoDigitalParam.tipo,
                        competencia: arquivoDigitalParam.competencia,
                        descricao_resumida: arquivoDigitalParam.descricao_resumida,
                        prestacao_contas_nome: arquivoDigitalParam.prestacao_contas_nome,
                        prestacao_contas_ano: arquivoDigitalParam.prestacao_contas_ano
                    });
                }
                else if(arquivoDigitalParam.tipo == 'licitacao'){
                    await this.getOrgaos();
                    let me = this;
                    me.itemsOrgaosLicitacao = [];
                    var dataLicitacaoLocal = moment(arquivoDigitalParam.licitacao_data).format('DD/MM/YYYY');
                    me.update_arquivo_digital = Object.assign({}, {
                        id: arquivoDigitalParam.id,
                        tipo: arquivoDigitalParam.tipo,
                        competencia: arquivoDigitalParam.competencia,
                        descricao_resumida: arquivoDigitalParam.descricao_resumida,
                        licitacao_orgaos: JSON.parse(arquivoDigitalParam.licitacao_orgaos),
                        licitacao_data: dataLicitacaoLocal,
                        licitacao_numero: arquivoDigitalParam.licitacao_numero,
                        licitacao_modalidade: arquivoDigitalParam.licitacao_modalidade,
                        licitacao_objeto: arquivoDigitalParam.licitacao_objeto,
                        licitacao_vencedor: JSON.parse(arquivoDigitalParam.licitacao_vencedor),
                        licitacao_valor: arquivoDigitalParam.licitacao_valor
                    });
                    let modalidadelicitacaoText = arquivoDigitalParam.licitacao_modalidade;
                    $.each(me.modalidades_licitacao, function (key, modalidade) {
                        if(modalidade.value == arquivoDigitalParam.licitacao_modalidade){
                            modalidadelicitacaoText = modalidade.text;
                        }
                    });
                    me.modalidade_licitacao = {
                        value: arquivoDigitalParam.licitacao_modalidade,
                        text: modalidadelicitacaoText
                    };

                    $.each(me.update_arquivo_digital.licitacao_orgaos, function (key, item) {
                        let temp = me.orgaos.filter(function(orgao) {
                            return orgao.value == item;
                        });
                        me.itemsOrgaosLicitacao.push(temp[0]);
                    });
                }
                else if(arquivoDigitalParam.tipo == 'setor_pessoal'){
                    this.update_arquivo_digital = Object.assign({}, {
                        id: arquivoDigitalParam.id,
                        tipo: arquivoDigitalParam.tipo,
                        competencia: arquivoDigitalParam.competencia,
                        descricao_resumida: arquivoDigitalParam.descricao_resumida,
                        setor_pessoal_nome: arquivoDigitalParam.setor_pessoal_nome,
                        setor_pessoal_cpf: arquivoDigitalParam.setor_pessoal_cpf,
                        setor_pessoal_cargo: arquivoDigitalParam.setor_pessoal_cargo,
                        setor_pessoal_secretaria: arquivoDigitalParam.setor_pessoal_secretaria
                    });
                }
                else if(arquivoDigitalParam.tipo == 'outros'){
                    this.update_arquivo_digital = Object.assign({}, {
                        id: arquivoDigitalParam.id,
                        tipo: arquivoDigitalParam.tipo,
                        competencia: arquivoDigitalParam.competencia,
                        descricao_resumida: arquivoDigitalParam.descricao_resumida
                    });
                }
            },
            emitEventGetArquivosDigital(){
                eventBus.$emit('eventGetArquivosDigital', this.currentPagePagination);
            },
            validateData(data){
                var regex = "(0[1-9]|[1-2][0-9]|3[0-1])\/(0[1-9]|1[0-2])\/[0-9]{4}";
                var re = new RegExp(regex);
                return (re.test(data));
            },
            validateCpf(strCPF){
                var Soma;
                var Resto;
                var i;
                Soma = 0;
                if (strCPF == "00000000000") {
                    return false;
                }
                for (i=1; i<=9; i++) {
                    Soma = Soma + parseInt(strCPF.substring(i-1, i)) * (11 - i);
                }
                Resto = (Soma * 10) % 11;
                if ((Resto == 10) || (Resto == 11))  {
                    Resto = 0;
                }
                if (Resto != parseInt(strCPF.substring(9, 10)) ) {
                    return false;
                }
                Soma = 0;
                for (i = 1; i <= 10; i++) {
                    Soma = Soma + parseInt(strCPF.substring(i-1, i)) * (12 - i);
                }
                Resto = (Soma * 10) % 11;
                if ((Resto == 10) || (Resto == 11))  {
                    Resto = 0;
                }
                if (Resto != parseInt(strCPF.substring(10, 11) ) ) {
                    return false;
                }
                return true;
            },
            checkFormEmpenho:function() {
                this.errors = [];
                if(this.update_arquivo_digital.empenho_numero &&
                    this.update_arquivo_digital.empenho_especie &&
                    this.update_arquivo_digital.empenho_data_emissao &&
                    this.update_arquivo_digital.empenho_credor &&
                    // this.update_arquivo_digital.empenho_documento_credor &&
                    this.update_arquivo_digital.empenho_objeto &&
                    this.update_arquivo_digital.empenho_unidade_orcamentaria_id &&
                    this.update_arquivo_digital.empenho_fornecedor &&
                    // this.update_arquivo_digital.empenho_classificacao_despesa &&
                    // this.update_arquivo_digital.empenho_acao &&
                    // this.update_arquivo_digital.empenho_acao &&
                    this.update_arquivo_digital.empenho_fonte_recursos &&
                    this.update_arquivo_digital.empenho_unidade_gestora_id &&
                    this.update_arquivo_digital.empenho_valor
                ) {
                    if(this.validateData(this.update_arquivo_digital.empenho_data_emissao) == false){
                        this.errors.push("Informe uma data válida");
                        $("#arquivo_digital_update_modal").scrollTop(0);
                        return false;
                    }
                    if(this.update_arquivo_digital.empenho_data_liquidacao && this.validateData(this.update_arquivo_digital.empenho_data_liquidacao) == false){
                        this.errors.push("Informe uma data de liquidação válida");
                        $("#arquivo_digital_update_modal").scrollTop(0);
                        return false;
                    }
                    if(this.update_arquivo_digital.empenho_data_pagamento && this.validateData(this.update_arquivo_digital.empenho_data_pagamento) == false){
                        this.errors.push("Informe uma data de pagamento válida");
                        $("#arquivo_digital_update_modal").scrollTop(0);
                        return false;
                    }
                    return true;
                }
                if(!this.update_arquivo_digital.empenho_numero) this.errors.push("Informe o número do empenho.");
                if(!this.update_arquivo_digital.empenho_especie) this.errors.push("Informe a espécie do empenho.");
                if(!this.update_arquivo_digital.empenho_data_emissao) this.errors.push("Informe a data de emissão.");
                if(!this.update_arquivo_digital.empenho_credor) this.errors.push("Informe o credor.");
                // if(!this.update_arquivo_digital.empenho_documento_credor) this.errors.push("Informe o CPF/CNPJ do credor.");
                if(!this.update_arquivo_digital.empenho_objeto) this.errors.push("Informe o objeto do empenho.");
                if(!this.update_arquivo_digital.empenho_unidade_orcamentaria_id) this.errors.push("Selecione a unidade orçamentária.");
                if(!this.update_arquivo_digital.empenho_fornecedor) this.errors.push("Informe o fornecedor.");
                // if(!this.update_arquivo_digital.empenho_classificacao_despesa) this.errors.push("Informe a classificação.");
                // if(!this.update_arquivo_digital.empenho_acao) this.errors.push("Informe a ação.");
                if(!this.update_arquivo_digital.empenho_fonte_recursos) this.errors.push("Informe a fonte de recursos.");
                if(!this.update_arquivo_digital.empenho_unidade_gestora_id) this.errors.push("Informe a unidade gestora.");
                if(!this.update_arquivo_digital.empenho_valor) this.errors.push("Informe o valor.");
                $("#arquivo_digital_update_modal").scrollTop(0);
                return false;
            },
            checkFormLiquidacao:function() {
                this.errors = [];
                if(this.update_arquivo_digital.liquidacao_empenho_numero &&
                    this.update_arquivo_digital.liquidacao_data_vencimento &&
                    this.update_arquivo_digital.liquidacao_numero_aviso &&
                    this.update_arquivo_digital.liquidacao_data_emissao &&
                    this.update_arquivo_digital.liquidacao_documento_fiscal &&
                    this.update_arquivo_digital.liquidacao_valor
                ) {
                    if(this.validateData(this.update_arquivo_digital.liquidacao_data_vencimento) == false){
                        this.errors.push("Informe uma data de vencimento válida");
                        $("#arquivo_digital_update_modal").scrollTop(0);
                        return false;
                    }
                    if(this.validateData(this.update_arquivo_digital.liquidacao_data_emissao) == false){
                        this.errors.push("Informe uma data de emissão válida");
                        $("#arquivo_digital_update_modal").scrollTop(0);
                        return false;
                    }
                    return true;
                }
                if(!this.update_arquivo_digital.liquidacao_empenho_numero) this.errors.push("Selecione o empenho da liquidação.");
                if(!this.update_arquivo_digital.liquidacao_data_vencimento) this.errors.push("Informe a data de vencimento da liquidação.");
                if(!this.update_arquivo_digital.liquidacao_numero_aviso) this.errors.push("Informe o número de aviso da liquidação.");
                if(!this.update_arquivo_digital.liquidacao_data_emissao) this.errors.push("Informe a data de emissão da liquidação.");
                if(!this.update_arquivo_digital.liquidacao_documento_fiscal) this.errors.push("Informe o documento fiscal da liquidação.");
                if(!this.update_arquivo_digital.liquidacao_valor) this.errors.push("Informe o valor da liquidação.");
                $("#arquivo_digital_update_modal").scrollTop(0);
                return false;
            },
            checkFormPagamento:function(){
                this.errors = [];
                if(this.update_arquivo_digital.pagamento_liquidacao_numero_aviso &&
                    this.update_arquivo_digital.pagamento_data_movimentacao &&
                    this.update_arquivo_digital.pagamento_numero_sequencia &&
                    this.update_arquivo_digital.pagamento_valor_pago &&
                    this.update_arquivo_digital.pagamento_conta_contabil
                ) {
                    if(this.validateData(this.update_arquivo_digital.pagamento_data_movimentacao) == false){
                        this.errors.push("Informe uma data de movimentação válida");
                        $("#arquivo_digital_update_modal").scrollTop(0);
                        return false;
                    }
                    return true;
                }
                if(!this.update_arquivo_digital.pagamento_liquidacao_numero_aviso) this.errors.push("Selecione a liquidação.");
                if(!this.update_arquivo_digital.pagamento_data_movimentacao) this.errors.push("Informe a data de movimentação do pagamento.");
                if(!this.update_arquivo_digital.pagamento_numero_sequencia) this.errors.push("Informe o número de sequência do pagamento.");
                if(!this.update_arquivo_digital.pagamento_valor_pago) this.errors.push("Informe o valor do pagamento.");
                if(!this.update_arquivo_digital.pagamento_conta_contabil) this.errors.push("Informe a conta contábil.");
                $("#arquivo_digital_update_modal").scrollTop(0);
                return false;
            },
            checkFormPrestacaoContas:function(){
                this.errors = [];
                if(this.update_arquivo_digital.prestacao_contas_nome &&
                    this.update_arquivo_digital.prestacao_contas_ano
                ) {
                    return true;
                }
                if(!this.update_arquivo_digital.prestacao_contas_nome) this.errors.push("Informe o nome.");
                if(!this.update_arquivo_digital.prestacao_contas_ano) this.errors.push("Informe o ano.");
                $("#arquivo_digital_update_modal").scrollTop(0);
                return false;
            },
            checkFormLicitacao:function(){
                let me = this;
                this.errors = [];
                if((this.update_arquivo_digital.licitacao_orgaos.length > 0) &&
                    this.update_arquivo_digital.licitacao_data &&
                    this.update_arquivo_digital.licitacao_numero &&
                    this.update_arquivo_digital.licitacao_modalidade &&
                    this.update_arquivo_digital.licitacao_objeto &&
                    this.update_arquivo_digital.licitacao_vencedor &&
                    this.update_arquivo_digital.licitacao_valor
                ) {
                    if(this.validateData(this.update_arquivo_digital.licitacao_data) == false){
                        this.errors.push("Informe uma data da licitação válida");
                        $("#arquivo_digital_update_modal").scrollTop(0);
                        return false;
                    }

                    let arrayCheckLicitacaoVencedor = [];
                    $.each(me.update_arquivo_digital.licitacao_vencedor, function (key, item) {
                        if(item.length > 0){
                            arrayCheckLicitacaoVencedor.push(item);
                        }
                    });
                    if(arrayCheckLicitacaoVencedor.length == 0){
                        this.errors.push("Informe o(s) vencedor(es) da licitação.");
                        return false;
                    }

                    return true;
                }
                if(this.update_arquivo_digital.licitacao_orgaos.length == 0) this.errors.push("Informe o(s) órgão(s).");
                if(!this.update_arquivo_digital.licitacao_numero) this.errors.push("Informe o número da licitação.");
                if(!this.update_arquivo_digital.licitacao_modalidade) this.errors.push("Selecione a modalide da licitação.");
                if(!this.update_arquivo_digital.licitacao_data) this.errors.push("Informe a data da licitação.");
                if(!this.update_arquivo_digital.licitacao_valor) this.errors.push("Informe o valor da licitação.");
                if(!this.update_arquivo_digital.licitacao_objeto) this.errors.push("Informe o objeto da licitação.");
                $("#arquivo_digital_update_modal").scrollTop(0);
                return false;
            },
            checkFormSetorPessoal:function(){
                this.errors = [];
                if(this.update_arquivo_digital.setor_pessoal_nome &&
                    this.update_arquivo_digital.setor_pessoal_cpf &&
                    this.update_arquivo_digital.setor_pessoal_cargo &&
                    this.update_arquivo_digital.setor_pessoal_secretaria
                ) {
                    if((this.update_arquivo_digital.setor_pessoal_cpf) &&
                        this.validateCpf(this.update_arquivo_digital.setor_pessoal_cpf) == false){
                        this.errors.push("Informe um número de CPF válido");
                        return false;
                    }
                    return true;
                }
                if(!this.update_arquivo_digital.setor_pessoal_nome) this.errors.push("Informe o nome.");
                if(!this.update_arquivo_digital.setor_pessoal_cpf) this.errors.push("Informe o CPF.");
                if(!this.update_arquivo_digital.setor_pessoal_cargo) this.errors.push("Informe o cargo.");
                if(!this.update_arquivo_digital.setor_pessoal_secretaria) this.errors.push("Informe a secretaria.");
                $("#arquivo_digital_update_modal").scrollTop(0);
                return false;
            },
            checkForm:function() {
                this.errors = [];

                if(this.update_arquivo_digital.tipo &&
                    this.update_arquivo_digital.competencia &&
                    this.update_arquivo_digital.descricao_resumida
                ) {
                    if(this.update_arquivo_digital.tipo == 'empenho'){
                        if(this.checkFormEmpenho() == false){
                            return false;
                        }
                    }
                    else if(this.update_arquivo_digital.tipo == 'liquidacao'){
                        if(this.checkFormLiquidacao() == false){
                            return false;
                        }
                    }
                    else if(this.update_arquivo_digital.tipo == 'pagamento'){
                        if(this.checkFormPagamento() == false){
                            return false;
                        }
                    }
                    else if(this.update_arquivo_digital.tipo == 'prestacao_contas'){
                        if(this.checkFormPrestacaoContas() == false){
                            return false;
                        }
                    }
                    else if(this.update_arquivo_digital.tipo == 'licitacao'){
                        if(this.checkFormLicitacao() == false){
                            return false;
                        }
                    }
                    else if(this.update_arquivo_digital.tipo == 'setor_pessoal'){
                        if(this.checkFormSetorPessoal() == false){
                            return false;
                        }
                    }
                    return true;
                }

                if(!this.update_arquivo_digital.tipo) this.errors.push("Selecione o tipo");
                if(!this.update_arquivo_digital.competencia) this.errors.push("Informe a competência.");
                if(!this.update_arquivo_digital.descricao_resumida) this.errors.push("Informe a descrição resumida");
                $("#arquivo_digital_update_modal").scrollTop(0);
            },
            updateArquivoDigital()
            {
                if(this.checkForm()){
                    this.isLoading = true;
                    axios.put('/arquivodigital/' + this.update_arquivo_digital.id, this.update_arquivo_digital)
                    .then(response => {
                        this.isLoading = false;
                        $("#arquivo_digital_update_modal").modal("hide");
                        toastr.success(response.data.message);
                        this.emitEventGetArquivosDigital();
                    })
                    .catch(error => {
                        let me = this;
                        this.isLoading = false;
                        let erroObject = error.response.data;
                        this.errors = [];
                        if( error.response.status === 422 ){
                            if (erroObject.errors) {
                                $.each(erroObject.errors, function (key, value) {
                                    me.errors.push(value[0]);
                                });
                            }
                        }
                        else {
                            toastr.error(erroObject.message);
                        }
                    });
                }
            },
            getOrgaos(){
                return new Promise(resolve => {
                    var urlOrgaos = '/orgao/combo';
                    this.isLoading = true;
                    axios({
                        method: 'GET',
                        url: urlOrgaos
                    })
                    .then(response => {
                        let me = this;
                        this.isLoading = false;
                        this.orgaos = [];
                        $.each(response.data, function (key, item) {
                            me.orgaos.push({
                                'value': item.id,
                                'text': item.nome
                            });
                        });
                        resolve();
                    })
                    .catch(error => {
                        this.isLoading = false;
                        toastr.error('Falha ao listar órgaos.');
                        resolve();
                    });
                });
            },
            getUnidadesOrcamentarias(){
                var urlUnidadesOrcamentarias = '/unidade/combo';
                this.isLoading = true;
                axios({
                    method: 'GET',
                    url: urlUnidadesOrcamentarias
                })
                .then(response => {
                    let me = this;
                    this.isLoading = false;
                    this.unidades_orcamentarias = [];
                    $.each(response.data, function (key, item) {
                        me.unidades_orcamentarias.push({
                            'value': item.id,
                            'text': item.nome
                        });
                    });
                })
                .catch(error => {
                    this.isLoading = false;
                    toastr.error('Falha ao listar unidades orçamentárias.');
                });
            },
            getEmpenhos(){
                var urlEmpenhos = '/arquivodigital/empenhos';
                this.isLoading = true;
                axios({
                    method: 'GET',
                    url: urlEmpenhos
                })
                .then(response => {
                    let me = this;
                    me.isLoading = false;
                    me.empenhos = [];
                    $.each(response.data, function (key, item) {
                        me.empenhos.push({
                            'value': item.empenho_numero,
                            'text': "Número: "+item.empenho_numero+". Credor: "+item.empenho_credor+". Valor: "+me.formatMoneyBr(item.empenho_valor)
                        });
                        if(me.update_arquivo_digital.liquidacao_empenho_numero == item.empenho_numero){
                            me.empenho = {
                                'value': item.empenho_numero,
                                'text': "Número: "+item.empenho_numero+". Credor: "+item.empenho_credor+". Valor: "+me.formatMoneyBr(item.empenho_valor)
                            };
                        }
                    });
                })
                .catch(error => {
                    this.isLoading = false;
                    toastr.error('Falha ao listar empenhos');
                });
            },
            getLiquidacoes(){
                var urlLiquidacoes = '/arquivodigital/liquidacoes';
                this.isLoading = true;
                axios({
                    method: 'GET',
                    url: urlLiquidacoes
                })
                .then(response => {
                    let me = this;
                    this.isLoading = false;
                    this.liquidacoes = [];
                    $.each(response.data, function (key, item) {
                        me.liquidacoes.push({
                            'value': item.liquidacao_numero_aviso,
                            'text': "Liquidação Nº Empenho: "+item.liquidacao_empenho_numero+". Aviso de Liquidação: "+item.liquidacao_numero_aviso+". Valor: "+me.formatMoneyBr(item.liquidacao_valor)
                        });
                        if(me.update_arquivo_digital.pagamento_liquidacao_numero_aviso == item.liquidacao_numero_aviso){
                            me.liquidacao = {
                                'value': item.liquidacao_numero_aviso,
                                'text': "Liquidação Nº Empenho: "+item.liquidacao_empenho_numero+". Aviso de Liquidação: "+item.liquidacao_numero_aviso+". Valor: "+me.formatMoneyBr(item.liquidacao_valor)
                            };
                        }
                    });
                })
                .catch(error => {
                    this.isLoading = false;
                    toastr.error('Falha ao listar liquidacoes');
                });
            },
            getUnidadesGestoras(){
                var urlUnidadesGestoras = '/unidadegestora/combo';
                this.isLoading = true;
                axios({
                    method: 'GET',
                    url: urlUnidadesGestoras
                })
                .then(response => {
                    let me = this;
                    this.isLoading = false;
                    this.unidades_gestoras = [];
                    $.each(response.data, function (key, item) {
                        me.unidades_gestoras.push({
                            'value': item.id,
                            'text': item.nome
                        });
                    });
                })
                .catch(error => {
                    this.isLoading = false;
                    toastr.error('Falha ao listar unidades gestoras.');
                });
            },
            formatMoneyBr(valor){
                var formatter = new Intl.NumberFormat('pt-br', {
                  style: "currency",
                  currency: "BRL"
                });
                return formatter.format(valor);
            },
        }
    }
</script>